module.exports = __webpack_public_path__ + "img/xiche.238b1083.png";